import uniqueId from 'lodash-es/uniqueId';
import { NotificationType } from '@stripcash/ui-kit/components/Notification';

import { DEFAULT_SYSTEM_NOTIFICATION_TIMEOUT } from 'common/constants/common';

import {
  hideNotificationAction,
  showNotificationAction,
} from '../reducers/systemNotifications';

export const hide =
  ({ id }: { id: string }) =>
  (dispatch) => {
    dispatch(hideNotificationAction(id));
  };

export function show(
  notification,
  options: { timeout?: number } = {
    timeout: DEFAULT_SYSTEM_NOTIFICATION_TIMEOUT,
  },
) {
  return (dispatch) => {
    const id = uniqueId('system_notification_');

    if (options.timeout) {
      setTimeout(() => {
        dispatch(hide({ id }));
      }, options.timeout);
    }

    return dispatch(showNotificationAction({ id, ...notification }));
  };
}

export function error(message, key = '', options = {}) {
  return (dispatch) =>
    dispatch(show({ message, type: NotificationType.Error, key }, options));
}

export function success(message, key = '', options = {}) {
  return (dispatch) =>
    dispatch(show({ message, type: NotificationType.Success, key }, options));
}

export function info(message, key = '', options = {}) {
  return (dispatch) =>
    dispatch(show({ message, type: NotificationType.Info, key }, options));
}

export function warning(message, key = '', options = {}) {
  return (dispatch) =>
    dispatch(show({ message, type: NotificationType.Warning, key }, options));
}
